import Loading from 'flow/components/ui-components/Loading';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { useHistory, useParams } from 'react-router-dom';
import { generatePath } from 'flow/utils/router-utils';
import Page from '../Page';
import Settings from './components/Settings';

interface Params {
    extensionKey: ExtensionKey;
    profileKey: ProfileKey;
}

const IncomingCallsProfile = () => {
    const history = useHistory();
    const { extensionKey, profileKey } = useParams<Params>();
    const { profiles, getProfile } = useProfiles(extensionKey);

    const profile = getProfile(profileKey);

    if (!profiles || !profile) {
        return <Loading />;
    }

    return (
        <Page
            header={profile.get('description')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.incoming-calls'], {
                        extensionKey,
                    }),
                )
            }
        >
            <Settings profile={profile} />
        </Page>
    );
};
export default IncomingCallsProfile;
